// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2262":"82cb5082","4158":"82cb5082"}[chunkId] + ".chunk.css";
};